import React, { useState, useEffect } from 'react';
import { Spin } from "antd";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import logoVerticaleTheme from "../../assets/images/logoVerticaleTheme.png";
import fileUploadIcon from "../../assets/images/fileUploadIcon.png";
import useRequest from "../../hooks/useRequest";

function NewPostModal({ show, onClose, onSuccess }) {
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    course: "",
    holes: "",
    media: "",
    isPrivate: false,
  });
  const [courseList, setCourseList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showCourseDropdown, setShowCourseDropdown] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedCourseName, setSelectedCourseName] = useState('');
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    error: null
  });

  // Get user location on component mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            error: null
          });
        },
        (error) => {
          setLocation({
            latitude: null,
            longitude: null,
            error: error.message
          });
        }
      );
    } else {
      setLocation({
        latitude: null,
        longitude: null,
        error: 'Geolocation is not supported by this browser.'
      });
    }
  }, []);

  // Load initial courses when location is available
  useEffect(() => {
    if (location.latitude && location.longitude) {
      fetchCourses();
    }
  }, [location.latitude, location.longitude]);

  // Fetch courses when search query changes
  useEffect(() => {
    if (location.latitude && location.longitude && searchQuery.length > 0) {
      fetchCourses();
      setShowCourseDropdown(true);
    } else if (searchQuery.length === 0) {
      setShowCourseDropdown(false);
    }
  }, [searchQuery]);

  const fetchCourses = () => {
    request({
      url: `/common/getNewcourse?search=${encodeURIComponent(searchQuery)}&latitude=${location.latitude}&longitude=${location.longitude}`,
      method: "GET",
      onSuccess: (data) => {
        setCourseList(data.data.docs);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // const submitData = { ...formData, holes: selectedValue };
    const submitData = {
      ...formData,
      holes: selectedValue,
      isPrivate: formData.isPrivate
    };
    request({
      url: "/app/post/add-post",
      method: "POST",
      data: submitData,
      onSuccess: (data) => {
        onClose();
        if (onSuccess) {
          onSuccess();
        } else {
          window.location.reload();
        }
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  // Add method to toggle privacy
  const togglePrivacy = () => {
    setFormData(prevData => ({
      ...prevData,
      isPrivate: !prevData.isPrivate
    }));
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    // Clear selected course if search query changes
    if (formData.course && event.target.value !== selectedCourseName) {
      setFormData({ ...formData, course: "" });
      setSelectedCourseName('');
    }
  };

  const handleCourseSelect = (courseId, courseName) => {
    setFormData({ ...formData, course: courseId });
    setSelectedCourseName(courseName);
    setSearchQuery(courseName);
    setShowCourseDropdown(false);
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const fileUploads = (event) => {
    setLoading(true);
    const file = event.target.files[0];
    const formdata = new FormData();
    formdata.append('image', file);

    request({
      url: "/common/image-upload",
      method: "POST",
      data: formdata,
      onSuccess: (data) => {
        setFormData({ ...formData, media: data.data.upload });
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      },
    });
  };

  const resetForm = () => {
    setFormData({
      title: "",
      description: "",
      course: "",
      holes: "",
      media: "",
      isPrivate: false,
    });
    setSelectedValue('');
    setSearchQuery('');
    setSelectedCourseName('');
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Modal
      show={show}
      size="lg"
      className="headerModals"
      onHide={handleClose}
      centered
    >
      <Modal.Header
        className="p-4 position-relative justify-content-center"
        closeButton
      >
        <Modal.Title>
          <img src={logoVerticaleTheme} alt="Logo" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Form className="row g-2" onSubmit={handleSubmit}>
          <Form.Label className="col-12 mb-0">New Post</Form.Label>
          <div className="col-12 mb-0">
            <div className="row">
              <div className="col-12 col-md-6">
                <Form.Group
                  controlId="formFile"
                  className="uploadFileOuter w-100 h-100"
                >
                  <Form.Label className="w-100 h-100 d-flex align-items-center justify-content-center">
                    <div className="uploadFile text-center profile-upload">
                      <Spin spinning={loading} size="large">
                        <div className="imgOuter">
                          {formData?.media && formData.media.endsWith('.mp4') ? (
                            <video src={`https://pwabucket1.s3.amazonaws.com/${formData.media}`} autoPlay="true" type="video/mp4" />
                          ) : (
                            <img src={formData?.media ? `https://pwabucket1.s3.amazonaws.com/${formData?.media}` : fileUploadIcon} alt="Upload" />
                          )}
                        </div>
                        <div className="txt mt-3">Upload Img or video</div>
                      </Spin>
                    </div>
                  </Form.Label>
                  <Form.Control className="d-none" type="file" name="media" onChange={fileUploads} />
                </Form.Group>
              </div>
              <div className="col-12 mt-md-0 mt-3 col-md-6">
                <div className="row gap-12">
                  <Form.Group className="col-12">
                    <Form.Control
                      className="sahdow-none"
                      type="text"
                      name="title"
                      required
                      placeholder="Title"
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group className="col-12 position-relative">
                    <Form.Control
                      as="textarea"
                      className="sahdow-none"
                      type="text"
                      name="description"
                      placeholder="Description"
                      value={formData.description}
                      onChange={handleChange}
                      rows={3}
                    />
                  </Form.Group>
                  <Form.Group controlId="formCourse" className="col-12 position-relative">
                    <Form.Label>Course</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Search for a course..."
                      value={searchQuery}
                      onChange={handleSearchChange}
                      onFocus={() => {
                        if (courseList.length > 0 && searchQuery.length > 0) {
                          setShowCourseDropdown(true);
                        }
                      }}
                      onBlur={() => {
                        // Delay hiding dropdown to allow for clicking
                        setTimeout(() => setShowCourseDropdown(false), 200);
                      }}
                    />
                    {showCourseDropdown && courseList.length > 0 && (
                      <div className="position-absolute w-100 bg-white border rounded shadow-sm"
                        style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                        {courseList.map((course) => (
                          <div
                            key={course.id}
                            className="p-2 border-bottom cursor-pointer"
                            style={{ cursor: 'pointer' }}
                            onMouseDown={() => handleCourseSelect(course.id, course.name)}
                          >
                            {course.name}
                          </div>
                        ))}
                      </div>
                    )}
                    {showCourseDropdown && courseList.length === 0 && searchQuery.length > 0 && (
                      <div className="position-absolute w-100 bg-white border rounded shadow-sm p-2"
                        style={{ zIndex: 1000 }}>
                        No courses found
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="col-12 mt-3">
                    <Form.Select
                      aria-label="Default select example"
                      name="holes"
                      value={selectedValue}
                      onChange={(e) => {
                        setSelectedValue(e.target.value);
                      }}
                    >
                      <option value="">Select Hole</option>
                      <option value="9">Hole 9</option>
                      <option value="18">Hole 18</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="col-12 mt-3 d-flex align-items-center">
                    <Form.Check
                      type="switch"
                      id="privacy-switch"
                      label={formData.isPrivate ? "Private Post Upload " : "Public Post Upload"}
                      checked={formData.isPrivate}
                      onChange={togglePrivacy}
                    />
                  </Form.Group>
                  <Form.Group className="col-12 mt-4 text-end">
                    <button
                      type="submit"
                      className="btn btnStyle1 btnTheme1 shadow-none px-5 text-center w-100"
                    >
                      Post
                    </button>
                  </Form.Group>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default NewPostModal;